import { render, staticRenderFns } from "./GumroadLicenseModal.vue?vue&type=template&id=3aa3b64f&scoped=true"
import script from "./GumroadLicenseModal.vue?vue&type=script&lang=js"
export * from "./GumroadLicenseModal.vue?vue&type=script&lang=js"
import style0 from "./GumroadLicenseModal.vue?vue&type=style&index=0&id=3aa3b64f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa3b64f",
  null
  
)

export default component.exports